import { render, staticRenderFns } from "./tuwen.vue?vue&type=template&id=1d943465&scoped=true&"
import script from "./tuwen.vue?vue&type=script&lang=js&"
export * from "./tuwen.vue?vue&type=script&lang=js&"
import style0 from "./tuwen.vue?vue&type=style&index=0&id=1d943465&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d943465",
  null
  
)

export default component.exports